module.exports = __webpack_public_path__ + "static/media/aalto.44f1a4a6.webp";